import { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import swal from "sweetalert";

import { LoadingSpinner } from "../../../../constants/const";
import { GetLanguageString } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";
import { ApiFinance } from "../ApiFinance";

const UpdateFinanceAccounts = ({
  setUpdateModal,
  financeAccountCategoryId,
  previouslySelectedFinanceAccounts,
  reload,
  setReload,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [financeAccounts, setFinanceAccounts] = useState([]);
  const [selectedFinanceAccounts, setSelectedFinanceAccounts] = useState(
    previouslySelectedFinanceAccounts || []
  );
  const [errors, setErrors] = useState({ selectedFinanceAccounts: "" });
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const toggle = () => setUpdateModal(false);

  const handleDrag = (e, ui) =>
    setPosition((prev) => ({ x: prev.x + ui.deltaX, y: prev.y + ui.deltaY }));

  const validate = () => {
    const temp = {
      selectedFinanceAccounts:
        selectedFinanceAccounts.length > 0
          ? ""
          : t("common_field_required_error"),
    };
    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  // Fetch finance accounts from backend
  useEffect(() => {
    setLoading(true);
    ApiFinance()
      .GetExpenseHeadsListFromFinanceSoftware()
      .then((res) => setFinanceAccounts(res.data || []))
      .catch((err) =>
        swal({
          title: "Error",
          text: err.response?.data || err.message,
          icon: "error",
          buttons: "OK",
        })
      )
      .finally(() => setLoading(false));
  }, []);

  const handleSelectChange = (selected) =>
    setSelectedFinanceAccounts(selected || []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      await ApiFinance().UpdateFinanceAccounts(
        financeAccountCategoryId,
        selectedFinanceAccounts
      );
      swal({
        title: t("finance_finance_accounts_updated"),
        className: GetSelectedLanguage() === "en" ? "" : "ur",
        icon: "success",
        buttons: "OK",
      });
      setReload(!reload);
      toggle();
    } catch (err) {
      swal({
        title: err.message || "Something went wrong",
        text: err.response?.data || "",
        icon: "error",
        buttons: "OK",
      });
      toggle();
    } finally {
      setLoading(false);
    }
  };
  console.log(selectedFinanceAccounts);

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen className="inmodal" autoFocus={false}>
        <ModalHeader tag="h4">
          <GetLanguageString props="finance_tab_finance_accounts_update" />
        </ModalHeader>

        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label className="col-form-label">
                  <GetLanguageString props="funds_account" />
                </Label>

                <Select
                  isMulti
                  options={financeAccounts}
                  value={selectedFinanceAccounts}
                  onChange={handleSelectChange}
                  getOptionValue={(opt) => opt.value}
                  getOptionLabel={(opt) => opt.label}
                  classNamePrefix="select"
                  className="basic-multi-select no-drag"
                  // components={{ MenuList: VirtualizedMenuList }}
                />

                {errors.selectedFinanceAccounts && (
                  <h4 className="text-error">
                    {errors.selectedFinanceAccounts}
                  </h4>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={toggle}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit">
                <GetLanguageString props="update" />
              </Button>
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default UpdateFinanceAccounts;
